import { Card, Typography, Container } from "@mui/material";
import ActionButton from "../account/ActionButton";
import AccessibilityIcon from "@mui/icons-material/Accessibility"
/**
 *  Notification card
 * @param {*} param0
 * @returns
 */

function NotificationCard({
    id,
    backgroundColor,
    textColor,
    title,
    textOne,
    textTwo,
    startTarget,
    onRemindLaterClick,
    handleStartClick
}) {

    return (
        <Card
            id={id}
            sx={{
                backgroundColor: `${backgroundColor}`,
                color: `${textColor}`,
                borderRadius: 0,
                boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)"
            }}
        >
            <Container sx={{ textAlign: "center", pt: 2, mt: 2, mb: -4 }}><AccessibilityIcon style={{ justifyContent: "center", alignItems: "center" }} sx={{ color: "primary.main", fontSize: 50, alignContent: "center" }} align="center">
            </AccessibilityIcon></Container>

            
                <Typography
                    sx={{
                        fontWeight: "bold",
                        fontSize: 25,
                        ml: 2,
                        mt: 5,
                        pt: 1.2,
                        flexGrow: 1,
                    }}
                    align="center"
                >
                    {title}
                </Typography>
            {
                <Typography
                    sx={{
                        fontSize: 16,
                        mt: 2,
                        mx: 2,
                    }}
                    align="center"
                >
                    {textOne}
                </Typography>
            }
            {<Typography sx={{
                fontStyle: 'italic',
                fontSize: 13,
                mt: 1,
                mx: 2,
            }} align="center">{textTwo}</Typography>}
            <Container sx={{ textAlign: "center", pt: 2, pb: 3, mt: 2 }}>
                <ActionButton
                    id='start-btn'
                    variant='contained'
                    buttonColor='secondary.main'
                    buttonTextColor='primary.contrastText'
                    borderColor='transparent'
                    hoverColor='primary.contrastText'
                    hoverBorderColor='secondary.main'
                    hoverTextColor='secondary.main'
                    buttonTitle='Start'
                    onClick={handleStartClick}
                />
            </Container>
            <Container sx={{ textAlign: "right", pb: 3 }}>
                <ActionButton
                    id='remind-me-later-btn'
                    borderColor='primary.dark'
                    buttonColor='transparent'
                    buttonTextColor='primary.dark'
                    buttonTitle='Remind me later...'
                    variant='outlined'
                    hoverColor='primary.dark'
                    hoverBorderColor={"primary.dark"}
                    hoverTextColor='secondary.contrastText'
                    onClick={onRemindLaterClick}
                />
            </Container>
        </Card >
    );
}

export default NotificationCard;